import React from 'react'
import PropTypes from 'prop-types'
import ResponsiveImage from '../../responsive-image'
import style from './index.scss'

const Hero = ({ images, currentImage, hasBackground }) => {
  if (hasBackground) {
    return (
      <div className={style.imageWrapper}>
        {images.map(image => (
          <ResponsiveImage
            key={image}
            className={style.mobileImage}
            desktopImageUrl={image}
            mobileImageUrl={image}
            mobileRatio="standard"
            desktopRatio="standard"
            numberOfItems={2}
            alt=""
          />
        ))}
        <ResponsiveImage
          className={style.imageOnBackground}
          desktopImageUrl={currentImage}
          mobileImageUrl={currentImage}
          mobileRatio="standard"
          desktopRatio="standard"
          numberOfItems={2}
          alt=""
        />
      </div>
    )
  } else {
    return (
      <ResponsiveImage
        className={style.imageWithoutBackground}
        desktopImageUrl={currentImage}
        mobileImageUrl={currentImage}
        mobileRatio="standard"
        desktopRatio="standard"
        numberOfItems={2}
        alt=""
      />
    )
  }
}

Hero.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string),
  hasBackground: PropTypes.bool,
  currentImage: PropTypes.string.isRequired,
}

Hero.defaultProps = {
  hasBackground: false,
}

export default Hero
